import React from "react";
import "./text-shimmer.css";

export const TextShimmer = ({ children, className = "", duration = 2 }) => {
  return (
    <span
      className={`shimmer-text ${className}`}
      style={{ "--shimmer-duration": `${duration}s` }}
    >
      {children}
    </span>
  );
};
